<template lang="pug">
    article.home

        Preloader

        Intro

        section.body-wrapper

            #participants.home__participants
                Participants

        router-view

</template>

<script>
const Preloader = () => import('@/components/Preloader.vue');
const Intro = () => import('@/components/Intro.vue');
const Participants = () => import('@/components/Participants.vue');
import {title, description} from '@/assets/data/data.json';

export default {
    name: 'Home',

    components: {
        Intro,
        Participants,
        Preloader
    },

    data() {
        return {
            title,
            description,
            pageLoaded: false
        };
    },

    mounted() {
        this.pageLoaded = true;
        this.$nextTick(function() {
            this.pageLoaded = true;
        });
        this.$store.commit('getLikesData');
    },

    methods: {
        visibilityChanged(isVisible, entry) {
            entry;
            if (isVisible) {
                document.body.setAttribute('style', '--theme: #000; --theme-alt: #fff;');
            } else {
                document.body.setAttribute('style', '--theme: #fff; --theme-alt: #000;');
            }
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';

.home {
    position: relative;
    z-index: 17;
    font-family: var(--font-main);
    display: flex;
    flex-direction: column;
    align-items: center;

    &__participants {
        width: 100%;
    }
}

.body-wrapper {
    position: relative;
    width: 100%;

    &__vistrigger {
        &-one {
            position: absolute;
            top: 10vh;
            height: 100%;
        }

        &-two {
            position: absolute;
            top: 100vh;
            height: 100%;
        }
    }
}

.information {
    position: relative;
    padding: 150px 0;

    display: grid;
    grid-template-columns: 5vw repeat(23, 1fr) 5vw;

    @media (--viewport-mobile-l) {
        padding: 10vw 0;
    }

    &__heading {
        font-family: var(--font-accent);
        font-size: 40px;
        text-align: center;
        grid-column: 6 / span 15;
    }

    &__text {
        margin-top: 20px;
        grid-column: 6 / span 15;
        grid-row: 2;
    }

    &__heading,
    &__text {
        @media (--viewport-mobile-l) {
            grid-column: 2 / span 23;
            text-align: left;
        }
    }
}
</style>
